import { render, staticRenderFns } from "./Body-All.vue?vue&type=template&id=76ae344a&scoped=true&"
import script from "./Body-All.vue?vue&type=script&lang=js&"
export * from "./Body-All.vue?vue&type=script&lang=js&"
import style0 from "./Body-All.vue?vue&type=style&index=0&id=76ae344a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae344a",
  null
  
)

export default component.exports